module.exports = "/assets/b63339d4c67ba669ab2322443f53d19b.png";